import React, { memo, ChangeEvent } from 'react'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import { TextInput } from 'components/atoms'

interface IShipperMilesProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
}

export const ShipperMiles = memo<IShipperMilesProps>(({ onChange, value: { shipperMiles } }) => {
  const shipperMilesHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    onChange({ shipperMiles: value })
  }

  return (
    <div className='col-md-4 col-xs-4'>
      <TextInput
        label='Shipper Miles'
        placeholder='Enter mileage'
        value={shipperMiles || ''}
        onChange={shipperMilesHandler}
        type='number'
        id='shipper-rates-shipper-miles'
        dataTest='modal-rate-shipper-miles'
      />
    </div>
  )
})
